import UTILITY_API from "../utility_api";

const getActivityCodesForCareerStage = (career_stage, query) => {
  const matchingObjects = career_stage.filter((element) =>
    query.includes(element.career_stage)
  );

  const activityCodes = matchingObjects.map((obj) => ({
    career_stage: obj.career_stage,
    activity_codes: obj.activity_codes,
  }));

  return activityCodes.length > 0 ? activityCodes : null;
};

const fetchCareerStage = async (career) => {
  try {
    const career_stage = await fetch(UTILITY_API + "/career_stage");
    if (!career_stage.ok) {
      throw new Error(`First API call failed: ${career_stage.statusText}`);
    }
    const career_stage_data = await career_stage.json();
    const activityCodes = getActivityCodesForCareerStage(
      career_stage_data,
      career
    );

    if (activityCodes) {
      const flattenedActivityCodes = activityCodes.flatMap(
        (obj) => obj.activity_codes
      );
      let updateDataQuery = {
        activitycodes: flattenedActivityCodes.join(","),
      };
      return updateDataQuery;
    }
  } catch (error) {
    console.error("Failed to fetch data:", error);
  }
};

export const handleCareerStageHelper = async (selectedOption) => {
  let career = [];
  selectedOption.map((item) => {
    career.push(item.value);
  });
  let updateDataQuery = await fetchCareerStage(career);
  return updateDataQuery;
};
